export default "__VITE_ASSET__D7DoH4Yt__"